// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"8f4865dd","142":"d172d7ae","167":"e9a4e06b","171":"0682e258","178":"c029fab9","359":"b10ad680","453":"ddf972df","504":"dc78d670","586":"18b65dba","622":"e0f35262"}[chunkId] + ".chunk.js";
};